import React from "react"
import PropTypes from "prop-types"
import tw from "twin.macro"

import { SectionTitle } from "./layout"

const FeatureCardContainer = tw.div`flex flex-col`
const FeatureCardIcon = tw.img`mx-auto`
const FeatureCardTitle = tw(SectionTitle)`md:text-center mb-1`
const FeatureCardContent = tw.p``
const FeatureCardBody = tw.div`flex-1`

const FeatureCard = ({ title, icon, content }) => (
  <FeatureCardContainer>
    <FeatureCardIcon src={icon} />
    <FeatureCardBody>
      <FeatureCardTitle>{title}</FeatureCardTitle>
      <FeatureCardContent>{content}</FeatureCardContent>
    </FeatureCardBody>
  </FeatureCardContainer>
)

FeatureCard.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired
}

export default FeatureCard
